export const ALLOWED_IMPORT_EXTENSIONS = ['.xls', '.xlsm', '.xlsx', '.csv'] as const;
export const ALLOWED_IMPORT_EXTENSIONS_TEXT = ALLOWED_IMPORT_EXTENSIONS.join(', ');

export const isAllowedImportFile = (fileName?: string): boolean => {
  const normalized = fileName?.toLowerCase() || '';
  return ALLOWED_IMPORT_EXTENSIONS.some((extension) => normalized.endsWith(extension));
};
